import {
  UserConsent,
  fullConsent,
  noConsent,
  consentWithoutTargeting
} from "cookiesConsent/domain/consent"

export interface ConsentStore {
  grant: (consent: UserConsent) => Promise<void>
}

export interface BannerMode {
  reconcile: (store: ConsentStore, consent: UserConsent) => Promise<void>
}

export class BlockingOptIn implements BannerMode {
  readonly name = `blocking-opt-in`

  reconcile = async (): Promise<void> => {}
}

export class PassiveOptOut implements BannerMode {
  readonly name = `passive-opt-out`

  reconcile = async (
    store: ConsentStore,
    consent: UserConsent
  ): Promise<void> => store.grant(consent)
}

export const blockingOptIn: BannerMode = new BlockingOptIn()
export const passiveOptOut: BannerMode = new PassiveOptOut()

export class GpcSignalled {
  readonly name = `gpc-signalled`

  optOutDefault = (): UserConsent => consentWithoutTargeting
}

export class GpcNotSignalled {
  readonly name = `gpc-not-signalled`

  optOutDefault = (): UserConsent => fullConsent
}

export type PrivacySignal = GpcSignalled | GpcNotSignalled

export const gpcSignalled = new GpcSignalled()
export const gpcNotSignalled = new GpcNotSignalled()

export interface JurisdictionRules {
  defaultConsent: (signal: PrivacySignal) => UserConsent
  bannerMode: () => BannerMode
}

export class GdprConsentRules implements JurisdictionRules {
  defaultConsent = (): UserConsent => noConsent

  bannerMode = (): BannerMode => blockingOptIn
}

export class CanadaConsentRules implements JurisdictionRules {
  defaultConsent = (signal: PrivacySignal): UserConsent =>
    signal.optOutDefault()

  bannerMode = (): BannerMode => passiveOptOut
}

export class UsConsentRules implements JurisdictionRules {
  defaultConsent = (signal: PrivacySignal): UserConsent =>
    signal.optOutDefault()

  bannerMode = (): BannerMode => passiveOptOut
}

export class DefaultConsentRules implements JurisdictionRules {
  defaultConsent = (signal: PrivacySignal): UserConsent =>
    signal.optOutDefault()

  bannerMode = (): BannerMode => passiveOptOut
}
